import {useCallback} from 'preact/hooks';

import {useBugsnag} from '~/foundation/Bugsnag/hooks';
import type {Cart} from '~/types/cart';
import {getHostname} from '~/utils/hostname';

export const useCart = () => {
  const {notify} = useBugsnag();

  const getCart = useCallback(async () => {
    const hostname = getHostname();
    try {
      const cartResponse = await fetch(`https://${hostname}/cart.js`);
      const cartJson = await cartResponse.json();
      return cartJson as Cart;
    } catch (error) {
      notify(
        new Error(
          `Failed to fetch cart token for ${hostname} due to error: ${error}`,
        ),
      );
      return {token: '', currency: '', items: []};
    }
  }, [notify]);

  return {getCart};
};
